
jQuery(document).ready(function($){

  $(".navbar #mob-search").on("input", function () {
    console.log("mobile");
      $(".row.blogs-row .blog-wrapper").css("display", "none");
      $(".row.blogs-row .blog-wrapper").each((index, item) => {
        if (
          $(".row.blogs-row .blog-wrapper")
            .eq(index)
            .find("a.title")
            .html()
            .toLowerCase()
            .includes($(".navbar #mob-search").val().toLowerCase())
        ) {
          $(".row.blogs-row .blog-wrapper").eq(index).css("display", "block");
        }
      });
    });

  $(document).ready(function () {
    // existing click event handler on click of sort
    $('.blog-filter-sort ul li').on('click', function () {
        let selectedVal = $(this).data('value');
        let $parent = $(this).parent().parent().parent().parent().parent().parent();
        let cards = $parent.find('.blog-wrapper');
        
        if (selectedVal == 'oldest') {
            cards.sort(function (a, b) {
                var dataIdA = new Date($(a).data('date'));
                var dataIdB = new Date($(b).data('date'));
                if (dataIdA < dataIdB) return -1;
                if (dataIdA > dataIdB) return 1;
                return 0;
            });
        } else if (selectedVal == 'latest') {
            cards.sort(function (a, b) {
                var dataIdA = new Date($(a).data('date'));
                var dataIdB = new Date($(b).data('date'));
                if (dataIdA > dataIdB) return -1;
                if (dataIdA < dataIdB) return 1;
                return 0;
            });
        } else {
            if (selectedVal == 'popular') {
                cards.sort(function (a, b) {
                    var popularPostA = parseInt($(a).data('custom-popular_post')) || 99999;
                    var popularPostB = parseInt($(b).data('custom-popular_post')) || 99999;
                    return popularPostA - popularPostB; // Sort in ascending order
                });
            }
        }
        
        $parent.find('.row:nth-child(2)').append(cards);
        $(this).parent().parent().find('value').html($(this).html());
    });

    // Trigger the click event on the first 'li' element
    $('.blog-filter-sort ul li').first().trigger('click');

    $('.category-btn').on('click', function () {
      // Trigger click on the first 'li' element
      $('.blog-filter-sort .latest').trigger('click');
    });
    
    $(this).find('ul').removeClass('active');
});


    $('.blog-filter-tag ul li').on('click', function () {
    let selectedTag = $(this).data('value');
    $('.blog-filter-tag ul li').removeClass('active');
    $(this).addClass('active');
    const $parent = $(this).parent().parent().parent().parent().parent().parent();
    const cards = $parent.find('.blog-wrapper');
    let count = 0 ;
    cards.each(i => {
      if(cards[i].classList.contains('visible-important')) {
        cards[i].classList.remove('visible-important')
      }
      let tags = cards[i].dataset.tags;
      if(selectedTag == undefined || tags.includes(selectedTag)) {
        cards[i].style.display = 'block';
        cards[i].classList.add('visible-important')
        count = count + 1 ;
        console.log(count);
      } else {
        cards[i].style.display = 'none';
        if(cards[i].classList.contains('visible-important')) {
          cards[i].classList.remove('visible-important')
        }
      }
      if(selectedTag == "All") {
        cards[i].style.display = 'block';
        cards[i].classList.add('visible-important')
        count = count + 1 ;
      }
    })
    if(count < 1) {
      $('.blogs-show-more').css('display', 'none');
      $('.no-blogs-found').css('display', 'inline-block');
    } else {
      $('.blogs-show-more').css('display', 'inline-block');
      $('.no-blogs-found').css('display', 'none');
    }
    $(this).parent().parent().find('value').html(selectedTag? selectedTag: 'All');
    if(!this.classList.contains('custom-blog-container')) {
    setInterval(() => {
        const filterTag = document.querySelector('.blog-filter .blog-selected-value > value');
        const filterTagValue = filterTag ? filterTag.innerText.trim() : '';

        // Select all blog-wrapper elements
        const blogWrappers = document.querySelectorAll('.blog-wrapper');
        if (filterTagValue != 'All') {
          blogWrappers.forEach(blogWrapper => {
          const tags = blogWrapper.getAttribute('data-tags');
          
          // Check if the data-tags attribute includes the filterTag value
          if (tags && tags.includes(filterTagValue)) {
            blogWrapper.style.display = 'block';  // Show the matched blog-wrapper
          } else {
            blogWrapper.style.display = 'none';   // Hide the unmatched blog-wrapper
          }
        });
          
        }
        
      }, 10); 
    }
  })

 $('.blog-selected-value').on('click', function () {
   $(this).find('ul').toggleClass('active');
 })


  var firstLoad1 = true;
  var firstLoad2 = true;
  // for tabs
  $('.category-btn button').on('click', function(){
    $('.category-btn button').removeClass('active');
    $(this).addClass('active');
    $('.blog-cat-cnt > li').removeClass('active');
    $(`#${$(this).attr('data-id')}`).addClass('active');
    let currentTab = document.querySelector(`#${$(this)[0].dataset.id}`)
    if(currentTab) {
    let blogCards = Array.from(currentTab.querySelectorAll('.blog-wrapper'));
    blogCards.map((card)=> {
      console.log(card);
      card.classList.add('visible-important');
      console.log(card);
    })
    }
    $(this).find('ul').toggleClass('active');
  })




  // top stories carousel
  $('.top-stories--car').owlCarousel({
        loop:false,
        margin:7,
        nav:true,
        dots:false,
        items:4,
        // stagePadding:100,
        autoWidth:true,
        navText:['<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M43.75 15L6.25 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 6.25L6.25 15L15 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 50 30" fill="none"> <path d="M6.25 15L43.75 15" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> <path d="M35 6.25L43.75 15L35 23.75" stroke="#413F47" stroke-linecap="round" stroke-linejoin="round"/> </svg>'],
        responsive:{
            300:{
                items:1,
                nav:false,
                dots:true,
              autoWidth:false,
            },
          768:{
              items:3,
          },
            1200:{
              items:4,
              autoWidth:true,
            }
        }
    });

  // for margin

  $('.home-container').css('margin-left', $('.stories-section .container').css('margin-left'))
  $('.top-stories--car .owl-nav .owl-prev').css('margin-left', parseFloat($('.stories-section .heading h2').css('margin-left'))+5)


  // view all button
  // if(window.innerWidth > 767){
  //   $('#blog-hair .blogs-row').attr('data-constant', $('#blog-hair .blogs-row').children().eq(0).height());
  // }
  // else{
  //   $('#blog-hair .blogs-row').attr('data-constant', $('#blog-hair .blogs-row').children().eq(0).height() * 2);
  // }

  // function showMore($currentTab){
  //   // var containerHeight = 0;
  //   // // const $currentTab = $('#blog-hair .blogs-row');
  //   // var maxClicks = Math.floor($currentTab.children().length / 4);
  //   // var currentClicks = 0;
  //   // if($currentTab.children().length % 4 == 0){
  //   //   maxClicks--;
  //   // }

  //   var card = 4;
  //   var start = 3;
  //   $currentTab.parent().find('.blogs-show-more').on('click', function(e){
  //     e.preventDefault();
  //     $currentTab.children(`:gt(${start}):lt(${card})`).css('display', 'block');
  //     // $currentTab.css('max-height', parseFloat($currentTab.children().eq(4).height()) + parseFloat($currentTab.css('max-height')));
  //     // prevHeight = $currentTab.height();
  //     // currentClicks++;
  //     // if(maxClicks <= currentClicks){
  //     //   $(this).hide();
  //     // }
  //     start += 4;
  //     if($currentTab.children().length-1<= start){
  //       // $(this).hide();
  //     }
  //   })
  // }

  
//   showMore($('#blog-hair .blogs-row'));
//   showMore($('#blog-body .blogs-row'));
//   showMore($('#blog-ingredients .blogs-row'));
// showMore($('#blog-category-page .blogs-row'));
//   $('#blog-hair .blogs-row').children(':gt(3)').css('display','none')
//   $('#blog-body .blogs-row').children(':gt(3)').css('display','none')
//   $('#blog-ingredients .blogs-row').children(':gt(3)').css('display','none')
// $('#blog-category-page .blogs-row').children(':gt(3)').css('display','none')

//   // if blogs are less than 4 then hide view showMore
//   function hideShowMore($target){
//     if($target.children().length <=4){
//         $target.parent().find('.blogs-show-more').hide();
//     }
//   }
//   hideShowMore($('#blog-hair .blogs-row'));
//   hideShowMore($('#blog-body .blogs-row'));
//   hideShowMore($('#blog-ingredients .blogs-row'));
//    hideShowMore($('#blog-category-page .blogs-row'));
})


// function calculateDistanceFromTop($parent) {
//     if($parent.find('.blogs-row').children().length>4){
//       var distanceFromTop = $parent.find('.blogs-show-more').offset().top - $(window).scrollTop();
//       // console.log(distanceFromTop);
//       if(distanceFromTop <=1020){
//         $parent.find('.blogs-show-more').click()
//       }
//     }
// }

// Scroll event handler to recalculate distance on scroll
  // $(window).on('scroll', function() {
  //       if($('#blog-category-page').hasClass('active')){
  //           calculateDistanceFromTop($('#blog-category-page'));
  //       }
  //   });



